import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AuthLayout from "../components/Layouts/AuthLayout";
import MainLayout from "../components/Layouts/MainLayout";
import PublicLayout from "../components/Layouts/PublicLayout";

import AuthGuard from "../components/RouterGuards/AuthGuard";
import AppLoader from "../components/AppLoader";

import MyProfile from "../components/MyProfile"
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import ResetPassword from "../pages/ResetPassword";
import PageNotFound from "../pages/404";
import FamilyMemberDetail from "../pages/FamilyMemberDetail";
import Faq from "../pages/Faq";
import Patients from "../pages/Patients";
import PatientDetail from "../pages/PatientDetail";
import EditStaff from '../pages/EditStaff';
import Report from "../pages/Report";
import NutritionCategory from "../pages/NutritionCategory";
import ReportDetail from "../pages/ReportDetail";
import MedicationReport from "../pages/MedicationReport"
import NutritionReport from "../pages/NutritionReport"
import NutritionFoodCategory from "../pages/NutritionFoodCategory"
import NutritionReportSupplement from "../pages/NutritionReportSupplement"
import NutritionSingleFood from "../pages/NutritionSingleFood"
import Settings from "../pages/Settings";
import PatientLayout from "../components/Layouts/PatientLayout";
import HowItWorks from "../pages/HowItWorks";

export default function RootRoutes() {
  const userRedirect = (nextState, replace) => {
    var redirectPath = nextState.location.pathname
    replace({
      pathname: redirectPath,
    })
  };

  return (
    <Suspense fallback={<AppLoader />}>
      <Router>
        <Routes>
          <Route path="/" element={
            <AuthGuard>
              <MainLayout>
                <Patients />
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <PatientDetail />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/edit-staff" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <EditStaff />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/reports/:report_name" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <Report />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/reports/:report_name/:detail_id" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <ReportDetail />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/medication-reports" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <MedicationReport />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/nutrition-report" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <NutritionReport />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/patient/:id/nutrition-category/:type/:filterKey" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <NutritionCategory />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/nutrition-supplement/:substance" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <NutritionReportSupplement />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/nutrition-single-foods/:name" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <NutritionSingleFood />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/nutrition-food-category/:food" element={
            <AuthGuard>
              <MainLayout>
                <PatientLayout>
                  <NutritionFoodCategory />
                </PatientLayout>
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/faq" element={
            <AuthGuard>
              <MainLayout>
                <Faq />
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/profile" element={
            <AuthGuard>
              <MainLayout>
                <MyProfile />
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/profile/:id" element={
            <AuthGuard>
              <MainLayout>
                <FamilyMemberDetail />
              </MainLayout>
            </AuthGuard>
          } />
          <Route path="/signup" element={
            <AuthLayout>
              <SignUp />
            </AuthLayout>
            }
          />
          <Route path="/login" element={
            <AuthLayout>
              <SignIn />
            </AuthLayout>
            } 
          />
          <Route path="/reset-password" element={
            <AuthLayout>
              <ResetPassword />
            </AuthLayout>
            } 
          />
          <Route path="/settings" element={
            <MainLayout>
              <Settings />
            </MainLayout>
            } 
          />
          <Route path="/faq" element={
            <MainLayout>
              <Faq />
            </MainLayout>
            } 
          />
          <Route path="/how-it-works" element={
            <MainLayout>
              <HowItWorks />
            </MainLayout>
            } 
          />
          <Route
            path='/*'
            onEnter={userRedirect}
            element={
              <PublicLayout>
                <PageNotFound />
              </PublicLayout>
            }
          />
        </Routes>
      </Router>
    </Suspense>
  );
}
